"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("./Bucket"));
class Compositions {
    constructor({ buckets }) {
        this.buckets = buckets;
    }
}
Compositions.fromJSON = (json) => {
    const { buckets } = Object.assign({}, json);
    if (!Array.isArray(buckets)) {
        throw new Error('buckets should be array');
    }
    try {
        const _buckets = buckets.map(bucket => Bucket_1.default.fromJSON(bucket));
        return new Compositions({
            buckets: _buckets,
        });
    }
    catch (_a) {
        throw new Error('.facets.composition must be a { buckets: { value: string; count: number }[]}');
    }
};
exports.default = Compositions;
